const content = {
  page_title: "POIs",
  location_overview: [
    {
      title: "All",
      icon: "mdi-map-legend",
      color: "primaryOutline",
      value: "All",
      tooltip: "All known POIs (Friendly & Non Friendly)",
    },
    {
      title: "Friendly",
      icon: "mdi-certificate-outline",
      color: "secondary",
      value: "Friendly",
      tooltip: " POIs which you have marked as friendly locations",
    },
    {
      title: "Non Friendly",
      icon: "mdi-card-bulleted-off-outline",
      color: "primaryDark",
      value: "Non-Friendly",
      tooltip: "POIs which you have marked as non-friendly locations",
    },
    {
      title: "Outside known",
      icon: "mdi-map-marker-circle",
      color: "orangered",
      value: "Outside Pois",
      tooltip: "Devices which are not at a saved/known POI",
    },
    {
      title: "No Location ",
      icon: "mdi-map-marker-off-outline",
      color: "error",
      value: "No Location",
      tooltip: "Devices which have not sent location data in a communication message",
    },
  ],
  maps_config: {
    id: "id",
    label: "TotalAssets",
    // Labels are asset counts, so group and cluster badges sum them
    sumLabel: true,
    lat: "CurrentLat",
    lng: "CurrentLng",
    isWatchlisted: "IsWatchlisted",
    infoText: "name",
    url: "device",
    type: "LocationType",
    markerType: "markerType",
    categories: [
      {
        label: "All POIs",
        value: "All",
      },
      {
        label: "Friendly POI",
        value: "Friendly",
      },
      {
        label: "Non-Friendly POI",
        value: "Non-Friendly",
      },
      {
        label: "Devices Outside POI",
        value: "Outside Pois",
      },
      {
        label: "Devices at Unknown Location",
        value: "No Location",
      },
    ],
  },
  maps_config_possible_pois: {
    id: "id",
    lat: "Lat",
    lng: "Lng",
    infoText: "DeviceList",
    markerType: "markerType",
    message: "Devices: ",
  },
  maps_config_poi: {
    id: "LocationID",
    label: "TotalAssets",
    // Labels are asset counts, so group and cluster badges sum them
    sumLabel: true,
    lat: "CurrentLat",
    lng: "CurrentLng",
    isWatchlisted: "IsWatchlisted",
    infoText: "FullName",
    type: "LocationType",
  },
  maps_unknown_config: {
    id: "id",
    label: "TotalAssets",
    // Labels are asset counts, so group and cluster badges sum them
    sumLabel: true,
    lat: "CurrentLat",
    lng: "CurrentLng",
    infoText: "name",
    url: "device",
    type: "LocationType",
  },
  maps_devices_config: {
    id: "id",
    label: "TotalAssets",
    // Labels are asset counts, so group and cluster badges sum them
    sumLabel: true,
    lat: "CurrentLat",
    lng: "CurrentLng",
    infoText: "name",
    url: "location",
    type: "LocationType",
  },
  AssetAllocation: {
    values: ["FluidAssets", "StaticAssets"],
    labels: ["Fluid Asset(s)", "Static Asset(s)"],
    colors: ["vtblue", "vtred"],
  },
  locations_table: [
    {
      align: "start",
      text: "POI Name",
      value: "FullName",
      value_2: "LocationAddress1",
      condition: "Non Friendly",
      value_3: "LocationType",
      sortable: true,
      of_type: "modal",
      color: "error lighten-2",
    },
    {
      text: "POI Category",
      value: "LocationCategory",
      of_type: "text",
    },
    {
      text: "Total Assets",
      value: "TotalAssets",
      of_type: "text",
    },
    {
      text: "Fluid Assets",
      value: "FluidAssets",
      of_type: "text",
    },
    {
      text: "Static Assets",
      value: "StaticAssets",
      of_type: "text",
    },
    {
      text: "Rate of Flow",
      value: "FlowRate",
      of_type: "rating",
    },
    {
      text: "Avg. Stay Duration",
      value: "Utilisation",
      of_type: "hours",
    },
    {
      text: "Assets Allocation",
      values: ["FluidAssets", "StaticAssets"],
      labels: ["Fluid Asset(s)", "Static Asset(s)"],
      colors: ["vtblue", "vtred"],
      sortable: false,
      of_type: "bar",
    },
    {
      text: "",
      value: "IsWatchlisted",
      sortable: false,
      of_type: "add_to_list",
    },
    {
      text: "",
      value: "moreActions",
      sortable: false,
      of_type: "action",
      values: ["EditDetails", "OpenAsPage"],
      labels: ["Edit Details", "Open as a Page"],
    },
  ],
  devices_table: [
    {
      align: "start",
      text: "Device ID",
      value: "DeviceID",
      sortable: true,
      of_type: "link",
      identifier: "DeviceID",
      url: "/device/",
    },
    {
      text: "Asset ID",
      value: "AssetID",
      of_type: "text",
    },
    {
      text: "Stay Duration",
      value: "StayDuration",
      of_type: "hours",
    },
    {
      text: "M. Type",
      value: "LastMessageType",
      of_type: "secondary_icon",
    },
    {
      text: "Last Message",
      value: "LastMessageTime",
      of_type: "date",
    },
    {
      text: "Battery",
      value: "BatteryStatus",
      of_type: "text",
    },
    {
      text: "Device Status",
      value: "DeviceStatus",
      of_type: "text",
    },
  ],
  unknown_devices_table: [
    {
      align: "start",
      text: "Device ID",
      value: "DeviceID",
      sortable: true,
      of_type: "link",
      identifier: "DeviceID",
      url: "/device/",
    },
    {
      text: "Asset ID",
      value: "AssetID",
      of_type: "text",
    },
    {
      text: "Last Known POI",
      value: "LastKnownPOI",
      of_type: "link",
      identifier: "LastKnownLocationID",
      url: "/location/",
    },
    {
      text: "M. Type",
      value: "LastMessageTypeAtKnownLocation",
      of_type: "secondary_icon",
    },
    {
      text: "Last M. Time",
      value: "LastMessageTimeAtKnownLocation",
      of_type: "date",
    },
    {
      text: "Battery",
      value: "BatteryStatus",
      of_type: "text",
    },
    {
      text: "Device Status",
      value: "DeviceStatus",
      of_type: "text",
    },
  ],
  possible_pois_table: [
    {
      align: "start",
      text: "Total Occurrences",
      value: "TotalOccurances",
      sortable: true,
      of_type: "text",
    },
    {
      text: "Device(s)",
      value: "DeviceList",
      of_type: "multi-link",
      url: "/device",
    },
    {
      text: "Latitute",
      value: "Lat",
      of_type: "number",
    },
    {
      text: "Longitude",
      value: "Lng",
      of_type: "number",
    },
    {
      text: "",
      value: "mdi-map-marker-circle",
      sortable: false,
      of_type: "action",
      condition: "Lat",
    },
  ],
  //tabs: ["POI Dashboard", "Journeys", "Cycle Analysis", "Devices"],
  tabs: [
    {
      label: "POI Dashboard",
      value: "POIDashboard",
    },
    {
      label: "Journeys",
      value: "Journeys",
    },
    {
      label: "Cycle Analysis",
      value: "CycleAnalysis",
    },
    {
      label: "Devices",
      value: "Devices",
    },
  ],
  LocationCategory: ["Depot", "Distributor", "Customer"],
  LocationType: ["Friendly", "Non Friendly"],
  journeys_table: [
    {
      align: "start",
      text: "Origin",
      value: "OriginName",
      value_2: "OriginAddress",
      sortable: true,
      of_type: "2-line-text",
    },
    {
      text: "",
      value: "AvgJourneyTime",
      sortable: false,
      of_type: "to-from",
    },
    {
      text: "Destination",
      value: "DestinationName",
      value_2: "DestinationAddress",
      sortable: true,
      of_type: "2-line-text",
    },
    {
      text: "Activity",
      value: "ActivityLevel",
      of_type: "text",
    },
    {
      text: "Assets at Destination",
      value: "AtDestination",
      of_type: "text",
    },
    {
      text: "Total Assets Moved",
      value: "TotalAssets",
      of_type: "text",
    },
    {
      text: "",
      value: "IsWatchlisted",
      sortable: false,
      of_type: "add_to_list",
    },
  ],
  cycles_table: [
    {
      align: "start",
      text: "",
      expand: "mdi-plus-box-outline",
      collapse: "mdi-minus-box-outline",
      sortable: false,
      of_type: "accordion",
    },
    {
      text: "Device ID ",
      value: "DeviceID",
      of_type: "link",
      identifier: "DeviceID",
      url: "/device/",
    },
    {
      text: "Number Of Cycles",
      value: "numberOfCycles",
      of_type: "text",
    },
    {
      text: "Avg Cycle Duration",
      value: "AvgRoundTripTimeHrs",
      of_type: "hours",
    },
    {
      text: "Max. Cycle Duration",
      value: "MaxCycleTime",
      of_type: "hours",
    },
    {
      text: "Variation",
      value: "Variation",
      of_type: "text",
    },
  ],
  cycles_data: [
    {
      align: "start",
      text: "",
      expand: "mdi-plus-box-outline",
      collapse: "mdi-minus-box-outline",
      sortable: false,
      of_type: "accordion",
    },
    {
      text: "Origin",
      value: "StartPoint",
      sortable: true,
      of_type: "2-line-text",
    },
    {
      text: "Cycle Duration",
      value: "TripTime",
      sortable: true,
      of_type: "to-from",
    },
    {
      text: "Destination",
      value: "FinalPoint",
      sortable: true,
      of_type: "2-line-text",
    },
    {
      text: "Last Seen At Origin",
      value: "LastSeenAtOrigin",
      of_type: "date",
    },
    {
      text: "Arrival Time At Destination",
      value: "ArrivalTimeAtDestination",
      of_type: "date",
    },
  ],
  cycles_details: [
    {
      align: "start",
      text: "ID",
      value: "sno",
      sortable: true,
      of_type: "text",
    },
    {
      text: "POI",
      value: "FullName",
      of_type: "text",
      location: {
        id: "LocationHistoryID",
        label: "SeqNo",
        lat: "LastLat",
        lng: "LastLng",
        infoText: "FullName",
        type: "marker",
      },
      condition: "outside pois",
    },
    {
      text: "POI Category",
      value: "LocationCategory",
      of_type: "text",
    },
    {
      text: "First Seen at POI",
      value: "EntryTime",
      of_type: "date",
    },
    {
      text: "Last Seen at POI",
      value: "LastSeenTime",
      of_type: "date",
    },
    {
      text: "Stay Duration",
      value: "StayDuration",
      condition: 24,
      color: "secondary",
      of_type: "highlight",
    },
    {
      text: "Trip Duration",
      value: "TripDuration",
      of_type: "text",
    },
  ],
  device_filters: {
    primary: ["All"],
    secondary: {
      list_checkbox: [
        {
          label: "Message Type",
          value: "MessageType",
          values: ["TwoWiFi", "Gps", "DownlinkAcknowledgement"],
        },
        {
          label: "Battery",
          value: "BatteryStatus",
          values: ["High", "Low", "Unknown"],
        },
        {
          label: "Device Status",
          value: "DeviceStatus",
          values: ["Fluid", "Static"],
        },
      ],
      range: [
        {
          label: "Stay Duration (in Hours)",
          min: 0,
          max: 500,
          value: "StayDuration",
        },
      ],
    },
  },
  arrival_time: {
    time: [
      {
        value: "0",
        label: "12 am",
      },
      {
        value: "1",
        label: "",
      },
      {
        value: "2",
        label: "2 am",
      },
      {
        value: "3",
        label: "",
      },
      {
        value: "4",
        label: "4 am",
      },
      {
        value: "5",
        label: "",
      },
      {
        value: "6",
        label: "6 am",
      },
      {
        value: "7",
        label: "",
      },
      {
        value: "8",
        label: "8 am",
      },
      {
        value: "9",
        label: "",
      },
      {
        value: "10",
        label: "10 am",
      },
      {
        value: "11",
        label: "",
      },
      {
        value: "12",
        label: "12 pm",
      },
      {
        value: "13",
        label: "",
      },
      {
        value: "14",
        label: "2 pm",
      },
      {
        value: "15",
        label: "",
      },
      {
        value: "16",
        label: "4 pm",
      },
      {
        value: "17",
        label: "",
      },
      {
        value: "18",
        label: "6 pm",
      },
      {
        value: "19",
        label: "",
      },
      {
        value: "20",
        label: "8 pm",
      },
      {
        value: "21",
        label: "",
      },
      {
        value: "22",
        label: "10 pm",
      },
      {
        value: "23",
        label: "",
      },
    ],
    days: [
      {
        value: "Monday",
        label: "Mon",
      },
      {
        value: "Tuesday",
        label: "Tue",
      },
      {
        value: "Wednesday",
        label: "Wed",
      },
      {
        value: "Thursday",
        label: "Thu",
      },
      {
        value: "Friday",
        label: "Fri",
      },
      {
        value: "Saturday",
        label: "Sat",
      },
      {
        value: "Sunday",
        label: "Sun",
      },
    ],
    colors: ["primaryGrey lighten-2", "primaryGrey", "primary lighten-3", "primary lighten-2", "primary"],
  },
  filters: {
    //primary: ["All", "Friendly", "Non-Friendly", "Watchlist"],
    primary: [
      {
        label: "All",
        value: "All",
      },
      {
        label: "Friendly",
        value: "Friendly",
      },
      {
        label: "Non-Friendly",
        value: "Non-Friendly",
      },
      {
        label: "Watchlist",
        value: "Watchlist",
      },
      {
        label: "Possible POIs",
        value: "Possible-Pois",
      },
    ],
    secondary: {
      list_checkbox: [
        {
          label: "Type",
          value: "LocationCategory",
          values: [],
        },
      ],
      range: [
        {
          label: "Rate of Flow",
          min: 0,
          max: 100,
          value: "FlowRate",
        },
        {
          label: "Avg. Stay Duration (in Hours)",
          min: 0,
          max: 500,
          value: "Utilisation",
        },
      ],
    },
  },
  text_expandAll: "EXPAND ALL",
  text_colapseAll: "COLAPSE ALL",
  assets_arrival_duration_select: [
    {
      label: "Last Week",
      value: "1",
    },
    {
      label: "Last 4 Weeks",
      value: "4",
    },
    {
      label: "Last 8 Weeks",
      value: "8",
    },
    {
      label: "Last 12 Weeks",
      value: "12",
    },
  ],
  assets_cycle_duration_select: [
    {
      label: "Last 4 Weeks",
      value: "4",
    },
    {
      label: "Last 8 Weeks",
      value: "8",
    },
    {
      label: "Last 12 Weeks",
      value: "12",
    },
  ],
};

export { content };
